import * as React from 'react'
import { Title } from '#app/components/page-title'

const GOOGLE_MAPS_API_KEY = 'AIzaSyCRN8s_qsBvKuGaSH-fhWdd-TND9pdoumg' // TODO: replace later
const VENUE_GOOGLE_PLACE_ID = 'ChIJkc8wAPtKjoAR02a68gIIdDU'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GOOGLE_MAPS_EMBED_URL = `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=place_id:${VENUE_GOOGLE_PLACE_ID}`

const INFORMATION = [
	// {
	// 	title: 'Address',
	// 	// @TODO: make address clickable to Maps / Google Maps
	// 	description: '15400 Montalvo Rd, Saratoga, CA 95070',
	// 	_id: 1,
	// },
	{
		title: 'Date',
		description: 'August 31st 2024',
		_id: 1,
	},
	{
		title: 'Ceremony',
		description:
			'Italianate Garden | seating starts at 3:00pm, doors close at 3:30pm',
		_id: 2,
	},
	{
		title: 'Reception',
		description:
			'Historic Villa | seating starts at 5:00pm, seating ends at 5:30pm',
		_id: 3,
	},
	{
		title: 'Dress Code',
		description: 'Semi Formal / Cocktail | No White Dresses',
		_id: 4,
	},
]

// const APPLE_MAPS_URL_BASE =
// 	'https://maps.apple.com/?address=15400%20Montalvo%20Rd,%20Saratoga,%20CA%20%2095070,%20United%20States&ll=37.245211,-122.031670&q=15400%20Montalvo%20Rd'
const GOOGLE_MAPS_URL_BASE =
	'https://www.google.com/maps/place/15400+Montalvo+Rd,+Saratoga,+CA+95070/@37.2466243,-122.0322205,17z/data=!3m1!4b1!4m6!3m5!1s0x808e4afb0030cf91:0x35740802f2ba66d3!8m2!3d37.2466243!4d-122.0296456!16s%2Fg%2F11csj0hqv3?entry=ttu'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AWS_PARKING_SRC =
	'https://s3.amazonaws.com/media.montalvoarts.org/uploads/documents/2014/June/Montalvo%20Map_small929.pdf'

export default function DetailsRoute() {
	return (
		<section className="container flex flex-1 flex-col justify-center bg-bg py-10 sm:py-6">
			<Title title="Details" />

			<h2 className="self-center text-2xl capitalize">important information</h2>

			<section className="grid-cols mt-10 grid grid-cols-[max-content_1fr] gap-4 self-center">
				<p className="text-2xl font-extrabold">Address</p>
				<a
					href={GOOGLE_MAPS_URL_BASE}
					target="_blank"
					rel="noreferrer noopener"
					className="text-2xl"
				>
					15400 Montalvo Rd, Saratoga, CA 95070
				</a>
				{INFORMATION.map(({ title, description, _id }) => (
					<React.Fragment key={_id}>
						<p className="text-2xl font-extrabold">{title}:</p>
						<p className="text-2xl">{description}</p>
					</React.Fragment>
				))}
			</section>

			<section className="mt-10 self-center">
				<p className="text-2xl italic">
					Parking is limited, please carpool with as many people as possible!
				</p>
			</section>

			<section className="mt-10 self-center md:max-w-[80%]">
				<h2 className="text-xl">Venue Map</h2>
				<div>
					<a href={AWS_PARKING_SRC} target="_blank" rel="noreferrer noopener">
						<img src="/img/parking.png" alt="Venue Map" />
					</a>
				</div>
			</section>

			{/* <div className="mx-auto mt-5 w-4/5 max-w-36">
				<h2>VENUE MAP</h2>
				<div className="padding-top-[56.25%] aspect-video w-100 relative">
					<iframe
						title="Google Maps of the venue"
						width={750}
						height={500}
						// className="absolute inset-0 h-full w-full"
						loading="lazy"
						allowFullScreen
						referrerPolicy="no-referrer-when-downgrade"
						src={GOOGLE_MAPS_EMBED_URL}
					/>
				</div>
				<iframe src={AWS_PARKING_SRC} height="100%" width="100%" />
			</div> */}
		</section>
	)
}
